module.exports = __webpack_public_path__ + "static/media/newfeature.7815b1b8.png";